// extracted by mini-css-extract-plugin
module.exports = {"box":"FlashPage_box_2jW9j","background":"FlashPage_background_fm5Y9","close":"FlashPage_close_zCyMI","copyInput":"FlashPage_copyInput_nepQ5"};